"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.EventContentCache = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

// TO-DO add better typing
var EventContentCache = function EventContentCache() {
  var _this = this;

  (0, _classCallCheck2["default"])(this, EventContentCache);
  (0, _defineProperty2["default"])(this, "_cachedContent", void 0);
  (0, _defineProperty2["default"])(this, "clear", function () {
    delete _this._cachedContent;
  });
  (0, _defineProperty2["default"])(this, "read", function () {
    return _this._cachedContent;
  });
  (0, _defineProperty2["default"])(this, "write", function (content) {
    _this._cachedContent = content;
  });
  (0, _defineProperty2["default"])(this, "shouldEnrichEventWithCachedContent", function (eventSpecs) {
    var eventIsClickstream = eventSpecs.type.includes('clickstream');
    var contentIsCached = _this._cachedContent;
    var eventLacksContent = !eventSpecs.data.content;
    return Boolean(eventIsClickstream && contentIsCached && eventLacksContent);
  });
  (0, _defineProperty2["default"])(this, "enrichEventData", function (data) {
    data.content = _this._cachedContent;
    return data;
  });
};

exports.EventContentCache = EventContentCache;
var _default = EventContentCache;
exports["default"] = _default;